import { Typography, TypographyVariants, TypographyColors } from '@carboledger/ui';
import { EMPTY_LIST } from '@/lib/utils';
import { useTranslations } from '@/hooks';
import { LinkedTag } from '../LinkedTag';
import styles from './LinkedEntityField.module.scss';

/**
 * Props:
 *   label     the field label above the tags
 *   items     [{ id, label, value }] — one removable tag each; `value` is handed to onRemove
 *   onRemove  (value) => void
 */
export const LinkedEntityField = ({ label, items = EMPTY_LIST, onRemove }) => {
  const t = useTranslations();

  // Nothing linked, nothing to say — a form can no longer create a link from here.
  if (items.length === 0) return null;

  return (
    <div className={styles.field}>
      <Typography variant={TypographyVariants.bodyXs} color={TypographyColors.secondary}>
        {label}
      </Typography>

      <div className={styles.chips}>
        {items.map((item) => (
          <LinkedTag
            key={item.id}
            label={item.label}
            removeLabel={t('COMMON_REMOVE')}
            onRemove={onRemove ? () => onRemove(item.value) : undefined}
          />
        ))}
      </div>
    </div>
  );
};
